import $http from 'axios'
import C from './config'
import ls from './LSstore'
import moment from 'moment'


let device = localStorage.getItem('deviceInfo')


let common = {
  /**
   * ajax请求
   * @param url
   * @param params
   * @param callback
   * @param type
   */
  load(url, params, callback, type) {
    let startTime = moment(), endTime, timeInfo, _this = this;
    $http({
      method: type ? type : 'POST',
      baseURL: C.APIhost,
      url: url,
      data: params,
      params: (type === 'get' || type === 'GET') ? params : '',
    }).then((res) => {
      callback(res.data);
      endTime = moment();

      if (!device || !device.name) {
        try {
          device = JSON.parse(localStorage.getItem('deviceInfo'))
        } catch (error) {
          device = {}
        }
      }
      timeInfo = {
        payload:JSON.stringify([{
          diff: endTime.diff(startTime, 'ms'),
          params: params,
          status: res.data.status_code,
          url: url,
          deviceId: device.device_sn,
          name: device.name,
          date: moment().format('YYYY-MM-DD HH:mm:ss'),
          is_connected: params.is_cache ? params.is_cache : false,

        }]) ,
      };
      if(params.auth_token){
        timeInfo.auth_token=params.auth_token
      }else{
        timeInfo.customer_token=params.customer_token
      }
      $http.post(C.APIhost+'/statistics/api_timeout', timeInfo)
      localStorage.setItem('timeInfo', timeInfo);
      // let userInfo= localStorage.getItem('userInfo')
      //TODO 返回值处理
      if (res.data && res.data.status_code !== 'SUCCEEDED') {

      }
    }).catch((err) => {
      if (err.response) {
        console.error(err)
        let status = err.response.status
        if (status === 401) {
          location.href = "/error?error=401"
        } else if (status === 404) {
          location.href = "/error?error=404"
        }
      } else {
        console.error(err)
        //TODO 错误处理
        // callback(err)
      }
    })
  },
  ls: ls,
  /**
   * 生成全局唯一标识符（GUID，Globally Unique Identifier）
   * @returns {string} 32位十六进制GUID
   */
  guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
      return v.toString(16)
    })
  },
  /**
   * 判断JSON
   *
   * @param {any} obj
   * @returns
   */
  isJson(obj) {
    var isjson = typeof (obj) == "object" && Object.prototype.toString.call(obj).toLowerCase() == "[object object]" && !obj.length;
    return isjson;
  },
  // 解决ios上input无法只读的问题
  selectInputFoc() {
    let inputSelect = document.getElementsByClassName('el-input__inner')
    for (let i = 0; i < inputSelect.length; i++) {
      inputSelect[i].onfocus = function () {
        this.blur()
      }
    }
  },
  getMax(numA, numB){
    if ((numA <0 || numA > 2000) && (numB <0 || numB > 2000)) {
      return 0;
    }
    if (numB <0 || numB > 2000) {
      return numA;
    }else if(numA <0 || numA > 2000){
      return numB;
    }
    if (numB < numA) { return numA;}
    return numB;
  },
  getPrecision(a) {
    if (!isFinite(a)) return 0;
    var e = 1, p = 0;
    while (Math.round(a * e) / e !== a) { e *= 10; p++; }
    return p;
  },
  /**
   * 创建窑号选框所需数据
   * @argument MaxAlias 最大窑数
   */
  creatAliasMeun(MaxAlias) {
    let sys_alias = [];
    for (let i = 0; i < MaxAlias; i++) {
      sys_alias.push({
        val: `${i + 1}`,
        label: `${i + 1}号窑`
      });
    }
    return sys_alias
  },
  isWeChat() {
    let ua = window.navigator.userAgent.toLowerCase();
    //通过正则表达式匹配ua中是否含有MicroMessenger字符串
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true;
    } else {
      return false;
    }
  }


}
export default common



// WEBPACK FOOTER //
// ./src/lib/common.js